import { ArrowRight, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { relativeTime } from "@/lib/format";
import { SERVICE_BY_KEY } from "./schemas";

/** Offers to pick up a quote left half-finished in this browser. */
export const WelcomeBackBanner = ({ session, onContinue, onStartOver }) => (
  <section className="mx-auto max-w-6xl px-4 sm:px-6">
    <div
      data-testid="resume-welcome-banner"
      role="status"
      className="tt-fade-in flex flex-col gap-4 rounded-xl border-2 border-primary bg-[color:var(--tt-teal-mist)] p-5 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="flex items-start gap-3">
        <RotateCcw className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
        <div>
          <p className="text-sm font-bold text-foreground">
            Welcome back — continue your {SERVICE_BY_KEY[session.service]?.title || "quote"} where
            you left off?
          </p>
          <p className="mt-0.5 text-xs text-[color:var(--tt-teal-deep)]">
            Saved {relativeTime(session.updated_at)} on this browser. Your answers are kept for 30
            days.
          </p>
        </div>
      </div>
      <div className="flex shrink-0 gap-2">
        <Button
          type="button"
          onClick={onContinue}
          data-testid="resume-continue-button"
          className="h-10"
        >
          Continue
          <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
        </Button>
        <Button
          type="button"
          variant="outline"
          onClick={onStartOver}
          data-testid="resume-start-over-button"
          className="h-10 bg-white"
        >
          Start over
        </Button>
      </div>
    </div>
  </section>
);
